module.exports = __webpack_public_path__ + "static/media/Facebook.7aec31ad.svg";